(function () {
    document.addEventListener("DOMContentLoaded", () => {
        /*
        const defaultBuyOption = 'suscription';
        
        setTimeout(() => {
            const defaultOption= document.querySelector(`#${defaultBuyOption}`);
            if (defaultOption) {
                defaultOption.click();
            }
        }, 500);
        */

        //Bloquear scroll de la app seal hacia las opciones suscripcion cuando seleccionas variante
        let originalScrollTo = window.scrollTo;
        let redirectScroll = false;

        window.scrollTo = function () {
            if (redirectScroll) {
                let target = document.querySelector('.product-form__buttons');
                
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                
                return; // Bloqueamos el scrollTo original de Seal
            }
            
            return originalScrollTo.apply(window, arguments);
        };

        document.addEventListener('change', function (e) {
            if (e.target.matches('input[data-variant-id-real]')) {
                redirectScroll = true;
                setTimeout(function () { redirectScroll = false; }, 600);
            }
        }, true);

        //Si el enlace tiene suscripcion cargamos la suscripcion en la ficha
        const params = new URLSearchParams(window.location.search);
        const suscripcion = params.get('suscripcion');
        const variantIdUrl = params.get('variant');

        if (suscripcion !== null && suscripcion == 1) {
            const defaultBuyOption = 'suscription';
            setTimeout(() => {
                const defaultOption= document.querySelector(`#${defaultBuyOption}`);
                if (defaultOption) {
                    defaultOption.click();
                }
            }, 500);
        }

        //Mostrar texto condiciones de variantes en suscripcion
        setTimeout(() => {
            if (variantIdUrl) {
                viewDescSuscriptionRule(parseInt(variantIdUrl, 10));
            }
        }, 500);

        document.querySelectorAll('input[type="radio"]').forEach(input => {
            input.addEventListener('click', function() {
                const selectedValue = this.value;                
                const variantId = Number(this.dataset.variantIdReal);

                viewDescSuscriptionRule(variantId);
            });
        });
       
        // escuchar cambios en variantes
        document.addEventListener('change', (e) => {
            if (e.target.matches('input[type="radio"]')) {
                actualizarEstadoBoton();
            }
        });

        // mostrar info suscripción
        const suscriptionInfo = document.querySelector(".buy-options-container_suscription-info");
        const suscriptionInfoDescription = document.querySelector(".buy-options-container_suscription-info-description");
        if (suscriptionInfo) {
            suscriptionInfo.addEventListener('click', (e) => {
                if (suscriptionInfoDescription.classList.contains('disable-info')) {
                    suscriptionInfoDescription.classList.remove('disable-info');
                    suscriptionInfo.style.background = "#181818";
                    suscriptionInfo.style.color = "#fff";
                
                } else {
                    suscriptionInfoDescription.classList.add('disable-info');
                    suscriptionInfo.style.background = "none";
                    suscriptionInfo.style.color = "rgba(0, 0, 0, 0.75)";
                }                
            });
        }

        //Mostrar packs en funcion seleccion pago unico vs suscripcion
        const packsContainer = document.querySelectorAll('.pack-container');

        const buyOptionsContainer = document.querySelectorAll(".buy-options-container div");
        let selectedBuyOptionId = 'single';
        
        buyOptionsContainer.forEach((buyOption) => {
            if (buyOption.classList.contains('selected')) {
                selectedBuyOptionId = buyOption.id; 
            }
                        
            buyOption.addEventListener('click', (e) => {
                const selectedBuyOption = e.currentTarget;
                const parentContainer = selectedBuyOption.closest('.buy-options-container');
                selectedBuyOptionId = e.currentTarget.id;                
                
                parentContainer.querySelectorAll('div').forEach(el => {
                    el.classList.remove('selected');
                });
                        
                packsContainer.forEach((packContainer) => {
                    const packContainerInputRadio = packContainer.querySelector('input[type="radio"]');
                    const packContainerPrice = packContainer.querySelector('.price-sale');
                    const packContainerOriginalPrice = packContainer.querySelector('.price-old, .price').textContent;
                    const packContainerPriceLegend = packContainer.querySelector('.capsula-price-discount');
                    const packContainerBubbleDiscounts = packContainer.querySelectorAll('.pack-container__bubble-discount');
                    const packContainerBadgets = packContainer.querySelectorAll('.pack-container__pack__header-badge');
                    const suscriptionInfoPlan = document.querySelector(".suscription-info-desc p");

                    //Click opcion compra unica
                    if (selectedBuyOptionId == 'single') {
                        const singleOption = document.querySelector('.sls-option[data-type="one_time"]');
                        
                        //Ocultar información del plan de suscripcion
                        suscriptionInfoPlan.parentElement.style.display = 'none';

                        //Ocultar informacion de suscripcion
                        if (!suscriptionInfo.classList.contains('disable-info')) {
                            suscriptionInfo.classList.add('disable-info');
                        }

                        //Visualizar bubbles discounts
                        packContainerBubbleDiscounts.forEach((packContainerBubbleDiscount) => {
                            if (packContainerBubbleDiscount.classList.contains('suscription')) {
                                if (!packContainerBubbleDiscount.classList.contains('disabled-bubble')) {
                                    packContainerBubbleDiscount.classList.add('disabled-bubble');
                                }                                

                            } else {
                                if (packContainerBubbleDiscount.classList.contains('disabled-bubble')) {
                                    packContainerBubbleDiscount.classList.remove('disabled-bubble');
                                }
                            }
                        });
                                            
                        if (packContainerInputRadio.hasAttribute('data-suscription-price')) {
                            const salePriceInSingle = packContainerInputRadio.dataset.singlePrice;
                            //Actualizar precio compra unica del pack con descuento previo
                            if (packContainerInputRadio.hasAttribute('data-original-price')) {                                
                                if (packContainerPrice) {
                                    packContainerPrice.textContent = salePriceInSingle;

                                    //Actualizar precio por capsula
                                    if (packContainerPriceLegend) {
                                        const capsulas = getCapsulas(packContainer);                                                                                                      
                                        const ahorro = getPriceByCapsula(packContainerOriginalPrice, salePriceInSingle, capsulas);

                                        if (ahorro) {
                                            packContainerPriceLegend.textContent = `Ahorras ${ahorro} € por cápsula`;
                                        }
                                    }
                                }

                                //Actualizar el % de descuento
                                packContainerBubbleDiscounts.forEach((packContainerBubbleDiscount) => {
                                    if (packContainerBubbleDiscount.classList.contains('suscription')) {
                                        return;
                                    }

                                    if (packContainerBubbleDiscount.hasAttribute('data-discount') && !packContainerBubbleDiscount.classList.contains('disabled-bubble')) {
                                        const percentajeDiscount = changePercentajeDiscount(packContainerOriginalPrice, salePriceInSingle);
                                        if (percentajeDiscount) {
                                            packContainerBubbleDiscount.innerHTML = '';

                                            const bubbleDiscountPercent = document.createElement('span');
                                            bubbleDiscountPercent.textContent = `-${Math.round(percentajeDiscount)}%`;
                                            packContainerBubbleDiscount.appendChild(bubbleDiscountPercent);
                                        }
                                        
                                    } else {                            
                                        packContainerBubbleDiscount.innerHTML = '';

                                        const bubbleDiscountPercent = document.createElement('span');                                        
                                        bubbleDiscountPercent.textContent = "";
                                        packContainerBubbleDiscount.appendChild(bubbleDiscountPercent);

                                        if (!packContainerBubbleDiscount.classList.contains('disabled-bubble')) {
                                            packContainerBubbleDiscount.classList.add('disabled-bubble');
                                        }
                                    }
                                });


                            } else {
                                //Actualizar precio compra unica del pack sin descuento previo
                                const container = packContainer.querySelector(".pack-container__pack__price-offer");
                                const capsulas = getCapsulas(packContainer);                                                                 
                                const ahorro = getPriceByCapsula(packContainerOriginalPrice, salePriceInSingle, capsulas);

                                container.innerHTML = "";

                                const priceSale = document.createElement('span');
                                priceSale.className = 'price';
                                priceSale.textContent = salePriceInSingle;

                                container.append(priceSale);

                                //Eliminar el % de descuento por ser solo precio original
                                packContainerBubbleDiscounts.forEach((packContainerBubbleDiscount) => {
                                    if (packContainerBubbleDiscount.classList.contains('suscription')) {
                                        return;
                                    }

                                    if (packContainerBubbleDiscount.hasAttribute('data-discount') && !packContainerBubbleDiscount.classList.contains('disabled-bubble')) {
                                        packContainerBubbleDiscount.classList.add('disabled-bubble');

                                        packContainerBubbleDiscount.innerHTML = '';

                                        const bubbleDiscountPercent = document.createElement('span');                                        
                                        bubbleDiscountPercent.textContent = "";
                                        packContainerBubbleDiscount.appendChild(bubbleDiscountPercent);

                                    } else {
                                        packContainerBubbleDiscount.remove();
                                    }                                    
                                });
                            }

                        } else {
                            if (packContainer.classList.contains('disabled')) {
                                packContainer.classList.remove('disabled');
                            }
                        }

                        //Visualizar badgets
                        packContainerBadgets.forEach((packContainerBadget) => {
                            if (packContainerBadget.classList.contains('suscription')) {
                                if (!packContainerBadget.classList.contains('disabled')) {
                                    packContainerBadget.classList.add('disabled');
                                }                                

                            } else {
                                if (packContainerBadget.classList.contains('disabled')) {
                                    packContainerBadget.classList.remove('disabled');
                                }
                            }
                        });

                        //Click sobre compra unica seal suscription
                        if (singleOption) {
                            singleOption.checked = true;
                            singleOption.dispatchEvent(new Event('change', { bubbles: true }));
                        }

                    } else {
                        //Click opcion suscripcion
                        const suscriptionOption = document.querySelector('.sls-option[data-type="subscription"]');
                        
                        //Ocultar información del plan de suscripcion
                        suscriptionInfoPlan.parentElement.style.display = 'block';

                        //Ocultar informacion de suscripcion
                        if (suscriptionInfo.classList.contains('disable-info')) {
                            suscriptionInfo.classList.remove('disable-info');
                        }

                        if (!packContainerInputRadio.hasAttribute('data-suscription-price')) {
                            //Eliminar el check del pack seleccionado si no esta en suscripcion
                            if (packContainerInputRadio && packContainerInputRadio.checked) {
                                packContainerInputRadio.checked = false;
                            }
                            packContainer.classList.add('disabled');
                        
                        } else {
                            const salePrice = packContainerInputRadio.dataset.suscriptionPrice;

                            //Visualizar bubbles discounts
                            packContainerBubbleDiscounts.forEach((packContainerBubbleDiscount) => {
                                if (packContainerBubbleDiscount.classList.contains('suscription')) {
                                    if (packContainerBubbleDiscount.classList.contains('disabled-bubble')) {
                                        packContainerBubbleDiscount.classList.remove('disabled-bubble');
                                    }

                                } else {
                                    if (!packContainerBubbleDiscount.classList.contains('disabled-bubble')) {
                                        packContainerBubbleDiscount.classList.add('disabled-bubble');
                                    }
                                }
                            });
                            
                            //Actualizar precio de suscripcion del pack sobre descuento previo
                            if (packContainerPrice) {
                                packContainerPrice.textContent = salePrice;

                                //Actualizar precio por capsula
                                if (packContainerPriceLegend) {
                                    const capsulas = getCapsulas(packContainer);
                                    //console.log(packContainerOriginalPrice + " / " + salePrice + " / " + capsulas);
                                    const ahorro = getPriceByCapsula(packContainerOriginalPrice, salePrice, capsulas);

                                    if (ahorro) {
                                        packContainerPriceLegend.textContent = `Ahorras ${ahorro} € por cápsula`;
                                    }
                                }

                            } else {
                                //Actualizar precio de suscripcion del pack sobre precio original sin descuento                                
                                const container = packContainer.querySelector(".pack-container__pack__price-offer");
                                const capsulas = getCapsulas(packContainer);                                                                 
                                const ahorro = getPriceByCapsula(packContainerOriginalPrice, salePrice, capsulas);

                                container.innerHTML = "";

                                const priceSale = document.createElement('span');
                                priceSale.className = 'price-sale';
                                priceSale.textContent = salePrice;

                                const separatorPrice = document.createElement('span');
                                separatorPrice.className = 'separator-price';
                                separatorPrice.textContent = ' - ';

                                const priceOld = document.createElement('span');
                                priceOld.className = 'price-old';
                                priceOld.textContent = packContainerOriginalPrice;

                                const separatorCapsula = document.createElement('span');
                                separatorCapsula.className = 'separator-capsula-price';
                                separatorCapsula.textContent = ' | ';

                                const nodes = [
                                    priceSale,
                                    separatorPrice,
                                    priceOld,
                                    separatorCapsula
                                ];

                                if (ahorro) {
                                    const capsulaDiscount = document.createElement('span');
                                    capsulaDiscount.className = 'capsula-price-discount';
                                    capsulaDiscount.textContent = `Ahorras ${ahorro} € por cápsula`;

                                    nodes.push(capsulaDiscount);
                                }

                                container.append(...nodes);
                            }

                            //Actualizar el % de descuento
                            const percentajeDiscount = changePercentajeDiscount(packContainerOriginalPrice, salePrice);
                            packContainerBubbleDiscounts.forEach((packContainerBubbleDiscount) => {
                                if (!packContainerBubbleDiscount.classList.contains('suscription')) {
                                    return;
                                }
                                                                                                                   
                                if (percentajeDiscount) {
                                    packContainerBubbleDiscount.innerHTML = '';

                                    const bubbleDiscountPercent = document.createElement('span');
                                    bubbleDiscountPercent.textContent = `-${Math.round(percentajeDiscount)}%`;
                                    packContainerBubbleDiscount.appendChild(bubbleDiscountPercent);
                                }

                                if (!packContainerBubbleDiscount.hasAttribute('data-discount') && packContainerBubbleDiscount.classList.contains('disabled-bubble')) {
                                    packContainerBubbleDiscount.classList.remove('disabled-bubble');
                                }

                                /*
                                else {
                                    if (percentajeDiscount) {
                                        const bubbleDiscountPercentBlock = document.createElement('span');
                                        bubbleDiscountPercentBlock.className = 'pack-container__bubble-discount';

                                        const bubbleDiscountPercent = document.createElement('span');
                                        bubbleDiscountPercent.textContent = `-${Math.round(percentajeDiscount)}%`;

                                        bubbleDiscountPercentBlock.append(bubbleDiscountPercent);
                                        packContainer.appendChild(bubbleDiscountPercentBlock);
                                    }
                                }
                                */
                            });
                        }

                        //Visualizar badgets
                        packContainerBadgets.forEach((packContainerBadget) => {
                            if (packContainerBadget.classList.contains('suscription')) {
                                if (packContainerBadget.classList.contains('disabled')) {
                                    packContainerBadget.classList.remove('disabled');
                                }

                            } else {
                                if (!packContainerBadget.classList.contains('disabled')) {
                                    packContainerBadget.classList.add('disabled');
                                }
                            }
                        });                        
                        
                        //Click sobre suscripcion seal suscription
                        if (suscriptionOption) {
                            suscriptionOption.checked = true;
                            suscriptionOption.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    }
                });
                
                selectedBuyOption.classList.add('selected');
                actualizarEstadoBoton();

                packsContainer.forEach((packContainer) => {
                    if (packContainer.classList.contains('selected')) {
                        const inputPack = packContainer.querySelector('input[type="radio"]');
                        if (inputPack) {
                            updSelectedPlan(inputPack, selectedBuyOptionId);
                        }
                    }  
                });
            });
        });

        //Seleccionar pack escogido en app seal suscription        
        packsContainer.forEach((packContainer) => {
            packContainer.addEventListener('click', (e) => {
                packsContainer.forEach(el => {
                    el.classList.remove('selected');
                });
                
                if (e.target.dataset.sellingPlanGroupInput !== undefined) {
                    updSelectedPlan(e.target, selectedBuyOptionId);

                } else {
                    updSelectedPlan(e.target, 'single');
                }

                packContainer.classList.add('selected');
            });
        });
    });

    function updSelectedPlan(pack, paidMode) {
        const plan = pack.dataset.sellingPlanGroupInput;
        const sealSuscriptionContainer = document.querySelector(`div.sls-option-container.seal-table[data-selling-plan-group="${plan}"]`);
        const singlePaidContainer = document.querySelector('div.sls-option-container.seal-table:not([data-selling-plan-group])');

        if (paidMode == 'single') {
            if (singlePaidContainer && !singlePaidContainer.classList.contains('sls-active')) {
                singlePaidContainer.click();
            }

        } else {
            if (sealSuscriptionContainer && !sealSuscriptionContainer.classList.contains('sls-active')) {
                sealSuscriptionContainer.click();
            }
        }
    }

    function cleanBlock(contenedor) {
        while(contenedor.firstChild) {
            contenedor.removeChild(contenedor.firstChild);
        }
    }

    function getCapsulas(block) {
        const container = block.querySelector('.pack-container__pack__header-name .capsulas');
        let numCapsulas = 0

        // Normaliza: minúsculas + sin tildes
        const texto = container.textContent
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');

        const match = texto.match(/\d+([.,]\d+)?/);

        if (match) {
            numCapsulas = parseInt(match[0]);
        }

        return numCapsulas;
    }

    function getPriceByCapsula (originalPrice, salePrice, totalCapsulas) {
        originalPrice = parseFloat(
            originalPrice
                .replace(/\s/g, '')
                .replace('€', '')
                .replace(',', '.')
        );

        salePrice = parseFloat(
            salePrice
                .replace(/\s/g, '')
                .replace('€', '')
                .replace(',', '.')
        );

        if (originalPrice && salePrice && totalCapsulas) {
            return ((originalPrice - salePrice) / totalCapsulas).toLocaleString('es-ES', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        }

        return 0;
    }

    function changePercentajeDiscount(originalPrice, salePrice) {
        originalPrice = parseFloat(
            originalPrice
                .replace(/\s/g, '')
                .replace('€', '')
                .replace(',', '.')
        );

        salePrice = parseFloat(
            salePrice
                .replace(/\s/g, '')
                .replace('€', '')
                .replace(',', '.')
        );

        if (originalPrice && originalPrice > 0) {
            return Math.round(((originalPrice - salePrice) * 100) / originalPrice);
        }

        return 0;
    }

    function actualizarEstadoBoton() {
        const btnSubmit = document.querySelector('form[action*="/cart/add"] [type="submit"]');
        const varianteSeleccionada = document.querySelector('.pack-container input[type="radio"]:checked');

        btnSubmit.disabled = !varianteSeleccionada;
    }

    function viewDescSuscriptionRule(variantId) {
        if (variantId !== null) {
            const productData = JSON.parse(window.essentialOrderValueBoosterMeta.productData);
            const suscriptionContainer = document.querySelector(".buy-options-container_suscription-purchase");
            const suscriptionInfoPlan = document.querySelector(".suscription-info-desc p");

            // Buscar la variante por su opción
            const variant = productData.variants.find(
                v => v.id === variantId
            );

            if (!variant) return;

            // Buscar el selling plan asociado a la variante
            const sellingPlanAllocation = variant.selling_plan_allocations?.[0];

            if (!sellingPlanAllocation) {
                suscriptionInfoPlan.textContent = '';
                return;
            }

            const sellingPlanGroup = productData.selling_plan_groups.find(
                group => group.id === sellingPlanAllocation.selling_plan_group_id
            );

            if (sellingPlanGroup) {
                suscriptionInfoPlan.textContent = sellingPlanGroup.options[0].name;
            }

            if (!suscriptionContainer.classList.contains('selected')) {
                suscriptionInfoPlan.parentElement.style.display = 'none';
            }
        }
    }
})();